import FooterColumn from './column';
import styles from './index.module.scss';
import logoImg from '@/assets/image/logo.png';
import { useNavigate } from 'react-router-dom';
import code from '@/assets/image/code.jpg';
import miniProgram from '@/assets/image/miniProgram.png';
import { useState, useEffect } from 'react';
// const arr = [
//   {
//     text: "产品",
//     url: 'xxxxxxxxxxxxxxx'
//   },
// ];

// const itemData = arr.map(item => {
//   return {
//     render() {
//       return <div onClick={window.goto(item.url)}>{ item.text}</div>
//     }
//   }
// })

const Footer = props => {
  const { productList } = props;
  const navigate = useNavigate();
  const itemData = [
    [
      { render: () => <div className={styles.titleFooter}>产品</div> },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList?data={"mallL1Categories":"1151"}&&title=加工工具产品');
              window.location.reload();
            }}>
            加工工具产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate(
                '/productList?data={"mallL1Categories":"1157"}&&title=阀门气动管道%20电机轴承产品'
              );
              window.location.reload();
            }}>
            阀门气动管道 电机轴承产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList?data={"mallL1Categories":"1150"}&&title=电气类产品');
              window.location.reload();
            }}>
            电气类产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate(
                '/productList?data={"mallL1Categories":"1159"}&&title=绿色照明%20智能安防监控产品'
              );
              window.location.reload();
            }}>
            绿色照明 智能安防监控产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList?data={"mallL1Categories":"1156"}&&title=办公仓储类产品');
              window.location.reload();
            }}>
            办公仓储类产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList?data={"mallL1Categories":"1155"}&&title=测量仪表产品');
              window.location.reload();
            }}>
            测量仪表产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate(
                '/productList?data={"mallL1Categories":"1158"}&&title=工业辅材及个人防护产品'
              );
              window.location.reload();
            }}>
            工业辅材及个人防护产品
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList?data={"mallL1Categories":"1154"}&&title=机械传送设备');
              window.location.reload();
            }}>
            机械传送设备
          </div>
        ),
      },
    ],
    [
      { render: () => <div className={styles.titleFooter}>采购指引</div> },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/register');
              window.location.reload();
            }}>
            用户注册
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/loginIn');
              window.location.reload();
            }}>
            用户登录
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/productList');
              window.location.reload();
            }}>
            产品搜索
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/selection-service/ximenzi');
              window.location.reload();
            }}>
            产品选型
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/quick-ordering');
              window.location.reload();
            }}>
            快速下单
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/cart');
              window.location.reload();
            }}>
            申请合同
          </div>
        ),
      },
    ],
    [
      { render: () => <div className={styles.titleFooter}>信息和服务</div> },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/product-information');
              window.location.reload();
            }}>
            产品资料
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/invoice-intro');
              window.location.reload();
            }}>
            发票说明
          </div>
        ),
      },
      // { render: () => <div className={styles.itemFooter} onClick={() => {
      //   navigate('/invoice-manage');
      //   window.location.reload();
      // }}>发票管理</div> },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/delivery-intro');
              window.location.reload();
            }}>
            配送说明
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/product-check');
              window.location.reload();
            }}>
            货物验收
          </div>
        ),
      },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              navigate('/after-sale');
              window.location.reload();
            }}>
            售后政策
          </div>
        ),
      },
    ],
    [
      { render: () => <div className={styles.titleFooter}>关于蓝格赛</div> },
      {
        render: () => (
          <div
            className={styles.itemFooter}
            onClick={() => {
              // navigate('www.rexel.com.cn');
              window.location.href = 'https://www.rexel.com.cn';
              // window.location.reload();
            }}>
            蓝格赛官网
          </div>
        ),
      },
    ],
  ];
  const [itemList, setItemList] = useState(itemData);
  useEffect(() => {
    if (!sessionStorage.getItem('productClass')) {
      let arr = [{ render: () => <div className={styles.titleFooter}>产品</div> }];
      let arrlist = productList?.map((item, index) => {
        return {
          render: () => (
            <div
              className={styles.itemFooter}
              onClick={() => {
                const paramsData = {
                  mallL1Categories: item?.categoriesCode,
                  mallL2Categories: '',
                  mallL3Categories: '',
                  mallL4Categories: '',
                  mallL5Categories: '',
                  keyWord: '',
                  pageNo: 1,
                  pageSize: 20,
                  brandIds:[],
                  sustainableOfferQualification: '',
                  hasStock: null,
                  attributes:[],
                }
                navigate(`/productList?data=${JSON.stringify(paramsData)}`);
                window.location.reload();
              }}>
              {item.categoriesName}
            </div>
          ),
        };
      });
      setItemList(v =>
        v.map((item, index) => {
          return index === 0 ? arr.concat(arrlist) : item;
        })
      );
    } else {
      const res2 = sessionStorage.getItem('productClass');
      const res1 = JSON.parse(res2);
      let arr = [{ render: () => <div className={styles.titleFooter}>产品</div> }];
      let arrlist = res1?.res?.map((item, index) => {
        return {
          render: () => (
            <div
              className={styles.itemFooter}
              onClick={() => {
                const paramsData = {
                  mallL1Categories: item?.categoriesCode,
                  mallL2Categories: '',
                  mallL3Categories: '',
                  mallL4Categories: '',
                  mallL5Categories: '',
                  keyWord: '',
                  pageNo: 1,
                  pageSize: 20,
                  brandIds:[],
                  sustainableOfferQualification: '',
                  hasStock: null,
                  attributes:[],
                }
                navigate(`/productList?data=${JSON.stringify(paramsData)}`);
                // navigate(`/productList?data={"mallL1Categories":"${item?.categoriesCode}"}`);
                window.location.reload();
              }}>
              {item?.categoriesName}
            </div>
          ),
        };
      });
      setItemList(v =>
        v.map((item, index) => {
          return index === 0 ? arr.concat(arrlist) : item;
        })
      );
    }
  }, [productList]);

  const rightImgClumns = [
    {
      render: () => (
        <div className={styles.imgBox}>
          <img src={code} alt="" />
          <span className={styles.imgSpan}>关注公众号</span>
        </div>
      ),
    },
    {
      render: () => (
        <div className={styles.imgBox}>
          <img src={miniProgram} alt="" />
          <span className={styles.imgSpan}>手机下单</span>
        </div>
      ),
    },
  ];
  const rightTextClumns = [
    {
      render() {
        return (
          <div className={styles.valueBox}>
            <div className={styles.label}>客服电话：</div>
            <div className={styles.value}>021-35961881 021-35961885</div>
          </div>
        );
      },
    },
    {
      render() {
        return (
          <div className={styles.valueBox}>
            <div className={styles.label}>意见建议：service.rexelmall@rexel.com.cn</div>
          </div>
        );
      },
    },
    {
      render() {
        return (
          <div className={styles.valueBox}>
            <div className={styles.label}>工作时间：周一至周五（9:00-18:00）</div>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <div className={styles.containBox}>
        <div className={styles.footerBox}>
          <div className={`${styles.leftBox}`}>
            {itemList.map((item, index) => (
              <FooterColumn key={index} index={index} data={item as any} />
            ))}
          </div>
          <div className={styles.Boxitem}>
            <div className={styles.imgBoxs}>
              {rightImgClumns.map((item, index) => {
                return <item.render key={JSON.stringify(item) + index} />;
              })}
            </div>

            <div
              style={{
                padding: `20px 0`,
              }}>
              {rightTextClumns.map((item, index) => {
                return <item.render key={JSON.stringify(item) + index}></item.render>;
              })}
            </div>
          </div>
        </div>
        {/* <div className={`${styles.footerLines}`}>
        <div className={styles.item}>友情链接:</div>
        <div className={styles.item}>四格互联</div>
        <div className={styles.item}>PPT演示</div>
        <div className={styles.item}>MES系统</div>
      </div> */}
        <div className={styles.footerText}>
          Copyright© 2006-{new Date().getFullYear()} 版权所有 蓝格赛电气有限公司备案号：沪ICP备12024648号-2
        </div>
      </div>
      {/* <div className={styles.footerTwo}>
      <div className={styles.text}>隶属于蓝格赛集团</div>
      <div className={styles.link}>
      <a href='http://www.rexel.com'>www.rexel.com</a>
      </div>
      <div className={styles.img}>
      <img src={logoImg} className={styles.img}></img>
      </div>
    </div> */}
      {/* <div className={styles.footerThree}>
      <div>© 2023 Oro Inc. All Rights Reserved.</div>
    </div> */}
    </div>
  );
};

export default Footer;
